import * as React from "react";
import { Nav, Row, Col, Container } from "react-bootstrap";
import { IAuthentication } from "../store/authentication";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IApplicationState } from "../store";
import * as instituteActions from "../store/institute/actions";
import { IInstitute } from "../store/institute";
import * as messageActions from "../store/message/actions";
import { IMessageFetchRequest } from "../store/message";
import MessageList from "../components/MessageList";

interface IPropertiesFromState {
  authentication?: IAuthentication;
  institutes: IInstitute[];
}

interface IPropertiesFromDispatch {
  instituteFetchRequest: typeof instituteActions.fetchRequest;
  fetchMessagesRequest: typeof messageActions.fetchRequest;
}

interface IMessagePageState {
  selectedPage: string;
  instituteId: number;
}

class MessagePage extends React.Component<IPropertiesFromState & IPropertiesFromDispatch, IMessagePageState> {

  public readonly state: IMessagePageState = {
    selectedPage: "",
    instituteId: -1,
  }

  public componentDidMount() {
    if (this.props.authentication == null) {
      return;
    }
    // if authenticated user is the sysadmin => load institutes
    // otherwise: load the messages of the institute which belongs to the user
    if (this.props.authentication.sysadmin) {
      this.props.instituteFetchRequest(false);
    } else {
      this.setState({instituteId: this.props.authentication.instituteId});
      this.props.fetchMessagesRequest({instituteId: this.props.authentication.instituteId, page: 0, pageSize: 10});
    }
  }

  public render() {
    const { authentication, institutes, fetchMessagesRequest } = this.props;

    const selectElda = () => {
      this.setState({selectedPage: "elda", instituteId: 0});
      fetchMessagesRequest({instituteId: 0, page: 0, pageSize: 10});
    }
    const selectInstitute = (institute: IInstitute) => {
      this.setState({selectedPage: `institute-${institute.id}`, instituteId: institute.id});
      fetchMessagesRequest({instituteId: institute.id, page: 0, pageSize: 10});
    }

    return (
      <>
        {authentication !== undefined && 
        <>
          {authentication.sysadmin && 
          <Container fluid={true} className="message-parent-box">
            <Row>
              <Col xs={2} className={"noPaddingRight"}>
                <Nav activeKey={this.state.selectedPage} className="flex-column nav-institute mh-100">
                  {authentication && authentication.sysadmin && <Nav.Link key={"elda"} eventKey="elda" onClick={() => selectElda()}>ELDA</Nav.Link>}
                  {institutes && institutes.map((institute) => {
                    return (<Nav.Link key={`institute-${institute.id}`} eventKey={`institute-${institute.id}`} onClick={() => selectInstitute(institute)}>{institute.name}</Nav.Link>);
                  })}
                </Nav>
              </Col>
              <Col xs={10} className={"noPaddingLeft noPaddingRight"}>
                <MessageList
                  instituteId={this.state.instituteId}
                />
              </Col>
            </Row>
            </Container>
          }
          {!authentication.sysadmin && 
            <>
              <Container fluid={true}>
                <MessageList
                  instituteId={this.state.instituteId}
                />
              </Container>
            </>
          }
        </>
        }
      </>
    );
  }
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    authentication: store.authentication.authentication,
    institutes: store.institute.data,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  instituteFetchRequest: (includeDeleted: boolean) => dispatch(instituteActions.fetchRequest(includeDeleted)),
  fetchMessagesRequest: (request: IMessageFetchRequest) => dispatch(messageActions.fetchRequest(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessagePage);
